export const flowActiveZH = {
  flowActive1: '我报名了',
  flowActive2: '，正在召集队员，邀请你和我一起参加！',
  flowActive3: '报名时间',
  flowActive4: '待定',
  flowActive5: '内容专区',
  flowActive6: '活动任务',
  flowActive7: '报名已结束',
  flowActive8: '立即报名',
  flowActive9: '即将开始',
  flowActive10: '即刻开启社会化学习，成就自我，塑造未来',
  flowActive11: '立即报名',
  flowActive12: '查看活动详情',
  flowActive13: '更多现场照片',
  flowActive14: '了解详情',
  flowActive15: '您的浏览器不支持 video 标签。',
  flowActive16: '我的活动',
  flowActive17: '认证中心',
  flowActive17b: '我的徽章',
  flowActive18: '有趣活动中还没发现你的身影?！',
  flowActive19: '去解锁新体验',
  flowActive20: '进度',
  flowActive21: '活动任务',
  flowActive22: '总体进度',
  flowActive23: '未解锁',
  flowActive24: '进行中',
  flowActive25: '已结束',
  flowActive26: '阶段进度',
  flowActive27: '已为你筛选出当前可完成的任务，先努力完成这些吧',
  flowActive28: '进度飞快，当前进行中的任务已全部完成',
  flowActive29: '查看全部任务',
  flowActive30: '距离截止还有',
  flowActive31: '前完成',
  flowActive32: '后可查看任务详情哦~',
  flowActive33: '立即前往',
  flowActive34: '算了，先逛逛',
  flowActive35: '知道了',
  flowActive36: '完成其中任意一个任务后，才可查看此任务哦',
  flowActive37: '完成',
  flowActive38: '任务后，才可查看此任务哦',
  flowActive39: '暂无数据',
  flowActive40: '请输入姓名',
  flowActive41: '重新生成证书成功！',
  flowActive42: '任务进度',
  flowActive43: '开始学习',
  flowActive44: '您还没有登录，请登录后查看“我的活动”',
  flowActive45: '更多讨论…',
  flowActive46: '天',
  flowActive47: '',
  flowActive48: '展开更多',
  flowActive49: '距离截止还有',
  flowActive50: '暂未获得证书哦~',
  flowActive51: '拼命加载题目中~',
  flowActive52: '题目解析',
  flowActive53: '正确答案',
  flowActive54: '你的答案',
  flowActive55: '解析',
  flowActive56: '上一题',
  flowActive57: '下一题',
  flowActive58: '提交',
  flowActive59: '练习时间',
  flowActive60: '当前进度',
  flowActive61: '答题卡',
  flowActive62: '答对',
  flowActive63: '答错',
  flowActive64: '未答',
  flowActive65: '请选择答案后提交',
  flowActive66: '请填写完答案后提交',
  flowActive67: '全部题已答完，是否结束练习?',
  flowActive68: '结束练习',
  flowActive69: '再看看',
  flowActive70: '已经是最后一题了!',
  flowActive71: '单选题',
  flowActive72: '多选题',
  flowActive73: '填空题',
  flowActive74: '测评时间',
  flowActive75: '已答',
  flowActive76: '未答',
  flowActive77: '全部题已答完，是否结束测评?',
  flowActive78: '结束测评',
  flowActive79: '答对题目数',
  flowActive80: '题目数量',
  flowActive81: '答错',
  flowActive82: '用时',
  flowActive83: '答对',
  flowActive84: '全部题目',
  flowActive85: '分',
  flowActive86: '秒',
  flowActive87: '成绩报告',
  flowActive88: '答题分析',
  flowActive89: '分数',
  flowActive90: '道',
  // 活动主页四模块 Tab
  flowActive91: '活动详情',
  flowActive92: '学习中心',
  flowActive93: '活动通知',
  flowActive94: '暂无通知',
  flowActive95: '后续活动的重要通知、学术公告和任务提醒都将在这里公布',
  flowActive96: '记得多多关注信息更新哦～',
  // 活动任务岛屿（PC 独立键，避开测评题干占用的 58–76）
  flowActive97: '当前任务',
  flowActive98: '去完成',
  flowActive99: '即将截止',
  flowActive100: '查看',
  flowActive101: '请先完成',
  flowActive102: '完成{index}解锁',
  flowActive103: '跳过',
  flowActive104: '截止时间 {date}',
  flowActive105: '{date} 开启',
  flowActive106: '未开启',
  flowActive107: '前置任务缺失',
  // 活动任务未报名空状态（Figma 2722:12108）
  flowActive108: '报名后解锁活动任务',
  flowActive109: '完成报名后，即可查看完整的任务流程，并解锁组队大厅',
  // 学习中心（避开测评占用的 53–76）
  flowActive110: '报名后解锁学习中心',
  flowActive111: '完成报名后，即可开始学习课程',
  flowActive112: '课程在报名后将陆续上线\n敬请期待～',
  flowActive113: '跳过功能即将开放',
  flowActive114: '再次复习',
  flowActive115: '继续学习',
  flowActive116: '{date}截止',
  flowActive117: '加载中…',
  flowActive118: '今日 {time} 开启'
}

export const flowActiveEN = {
  flowActive1: `I've registered for `,
  flowActive2: ' and am currently forming a team. I invite you to join me!',
  flowActive3: 'Registration Period',
  flowActive4: 'To Be Announced',
  flowActive5: 'Content Zone',
  flowActive6: 'Tasks',
  flowActive7: 'Registration Closed',
  flowActive8: 'Register Now',
  flowActive9: 'Starting Soon',
  flowActive10: 'Start Social Learning Now, Achieve Personal Growth, Shape Your Future',
  flowActive11: 'Register Now',
  flowActive12: 'Further Details',
  flowActive13: 'More Photos',
  flowActive14: 'Learn More',
  flowActive15: 'Your browser does not support the video tag.',
  flowActive16: 'My Activities',
  flowActive17: 'Authentication Center',
  flowActive17b: 'My Badges',
  flowActive18: `Haven't spotted you yet in a fun activity?!`,
  flowActive19: 'To unlock new experiences',
  flowActive20: 'Progress',
  flowActive21: 'Activity Tasks',
  flowActive22: 'Overall Progress',
  flowActive23: 'Unlocked',
  flowActive24: 'Ongoing',
  flowActive25: 'Ended',
  flowActive26: 'Stage Progress',
  flowActive27: `Now that you've been screened out of the tasks that can be completed at the moment, let's try to complete them first`,
  flowActive28: 'Progress is fast, and all the tasks currently in progress have been completed',
  flowActive29: 'View all tasks ',
  flowActive30: ' day(s) to deadline',
  flowActive31: 'Need to becompleted before ',
  flowActive32: ' you can view the task details~',
  flowActive33: 'Go now',
  flowActive34: `Later`,
  flowActive35: 'Got it',
  flowActive36: 'You can only view this task after completing any of these tasks',
  flowActive37: 'After completing the ',
  flowActive38: 'task, you can view this task',
  flowActive39: 'No data',
  flowActive40: 'Please enter your name',
  flowActive41: 'Certificate regeneration successful!',
  flowActive42: 'Task progress',
  flowActive43: 'Start',
  flowActive44: 'You have not logged in, please check "My activities" after logging in',
  flowActive45: 'More on...',
  flowActive46: '',
  flowActive47: 'After',
  flowActive48: 'More',
  flowActive49: ' to deadline',
  flowActive50: 'I haven\'t obtained the certificate yet~',
  flowActive51: 'Loading questions desperately~',
  flowActive52: 'Title Analysis',
  flowActive53: 'Correct Answer',
  flowActive54: 'Your answer',
  flowActive55: 'Answer Analysis',
  flowActive56: 'Previous',
  flowActive57: 'Next',
  flowActive58: 'Submit',
  flowActive59: 'Time',
  flowActive60: 'Progress',
  flowActive61: 'Answer',
  flowActive62: 'Correct',
  flowActive63: 'Wrong',
  flowActive64: 'Not answered',
  flowActive65: 'Please select an answer and submit',
  flowActive66: 'Please fill in the answer and submit',
  flowActive67: 'All questions have been answered. Is it time to end?',
  flowActive68: 'End',
  flowActive69: 'Wait',
  flowActive70: 'This is already the last question!',
  flowActive71: 'Single',
  flowActive72: 'Multiple',
  flowActive73: 'Fill-in',
  flowActive74: 'Time',
  flowActive75: 'Answered',
  flowActive76: 'Not answered',
  flowActive77: 'All questions have been answered. Is it time to end?',
  flowActive78: 'End',
  flowActive79: 'Correct',
  flowActive80: 'Number',
  flowActive81: 'Wrong',
  flowActive82: 'Time',
  flowActive83: 'Correct',
  flowActive84: 'All Questions',
  flowActive85: 'm',
  flowActive86: 's',
  flowActive87: 'Report',
  flowActive88: 'Analysis',
  flowActive89: 'Score',
  flowActive90: '',
  // Activity home module tabs
  flowActive91: 'Details',
  flowActive92: 'Learning',
  flowActive93: 'Notices',
  flowActive94: 'No notifications yet',
  flowActive95: 'Important notices, academic announcements, and task reminders will be posted here.',
  flowActive96: 'Remember to check back for updates~',
  // Activity task island (PC-only keys)
  flowActive97: 'Current task',
  flowActive98: 'Go',
  flowActive99: 'Close soon',
  flowActive100: 'View',
  flowActive101: 'Complete prerequisite first',
  flowActive102: 'Complete {index} to unlock',
  flowActive103: 'Skip',
  flowActive104: 'Close on {date}',
  flowActive105: 'Opens {date}',
  flowActive106: 'Not open',
  flowActive107: 'Prerequisite missing',
  // Activity tasks locked until registration (Figma 2722:12108)
  flowActive108: 'Unlock activity tasks after registration',
  flowActive109: 'Complete registration to view the full task flow and unlock the team lobby',
  // Learning center
  flowActive110: 'Unlock Learning Center after registration',
  flowActive111: 'Complete registration to start learning courses',
  flowActive112: 'Courses will be available after registration.\nStay tuned~',
  flowActive113: 'Skip will be available soon',
  flowActive114: 'Review',
  flowActive115: 'Continue',
  flowActive116: 'Close on {date}',
  flowActive117: 'Loading…',
  flowActive118: 'Open at {time} today'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/active.js